import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function CoinsIcon({ className, size = 24, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        d="M10 10C10 12.2091 8.20914 14 6 14C3.79086 14 2 12.2091 2 10C2 7.79086 3.79086 6 6 6C8.20914 6 10 7.79086 10 10Z"
        fill="currentColor"
      />
      <path
        d="M10.6261 10.618C12.5378 10.3174 14 8.6628 14 6.66667C14 4.45753 12.2091 2.66667 10 2.66667C8.25637 2.66667 6.77331 3.78231 6.22572 5.3387C8.69822 5.45644 10.6667 7.49834 10.6667 10C10.6667 10.2095 10.6529 10.4158 10.6261 10.618Z"
        fill="currentColor"
      />
    </svg>
  )
}
